import { IAdvancedFormConfig } from '~shared/modules/advanced-form/models/advanced-form.model';
import { FIELD_TYPES } from '~shared/modules/advanced-form/constants/field-types.constant';

export const CHANGE_EMAIL_FORM_CONFIG: IAdvancedFormConfig = {
  formSectionList: [
    {
      fieldList: [
        {
          name: 'email',
          label: 'REGULAR.FIELDS.CURRENT_EMAIL.LABEL',
          type: FIELD_TYPES.email,
          isDisabled: true,
        },
        {
          name: 'newEmail',
          label: 'REGULAR.FIELDS.NEW_EMAIL.LABEL',
          type: FIELD_TYPES.email,
        },
        {
          name: 'confirmationPassword',
          label: 'REGULAR.FIELDS.PASSWORD.LABEL',
          type: FIELD_TYPES.password,
        }
      ],
    }
  ],
  actionList: [
    {
      type: 'submit',
      text: 'PAGES.ACCOUNT.INFO.CHANGE_EMAIL.SUBMIT_BUTTON',
    }
  ],
  legalText: 'PAGES.AUTH.LOGIN.NOTICE'
};
